import * as reviewActions from './reviewActions';

const initialState = {};

const submissionReducer = (state = initialState, action) => {
  switch (action.type) {
    case reviewActions.SUBMIT:
      return state;

    default:
      return state;
  }
};

export default submissionReducer;



// WEBPACK FOOTER //
// ./src/review/reviewReducer.js